import { TreeNode } from '../route-builder';

export const OrgManagementModule = {
  segment: 'org-management'
} as const satisfies TreeNode;
